<template>
  <div class="news f-column-b">
    <block-head-line title="通知公告" :more-btn-url="moreBtnUrl" />
    <ul class="news-list">
      <li v-for="data in dataList" :key="data.id" class="news-item f-b-c">
        <Link class="f-b-c" :to="{path:`/info/detail/${code}`, query: {id: data.id}}" :title="data.title" target="_blank">
          <span class="text-cut">{{ data.title }}</span>
          <span class="time fc99 pl-10">{{ data.releaseTime | formatterDate }}</span>
        </Link>
      </li>
    </ul>
  </div>

</template>

<script>
import { NAV_MENU_CODE } from "@/utils/constant";
import infoApi from "@/api/information";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";

export default {
  name: "TabNews",
  components: { BlockHeadLine, Link },
  props: {
  },
  data() {
    return {
      code: NAV_MENU_CODE.NOTICES,
      dataList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return "/info/list/" + this.code
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
  },
  // 方法集合
  methods: {
    loadListData() {
      const params = {
        pageNo: 1,
        pageSize: 8
      };
      infoApi.page({ ...params, columnId: this.$getMenuIdByCode(this.code) }).then(res => {
        this.dataList = res.data?.list ?? []
      })
    }
  }
};
</script>

<style scoped lang="scss">
.news{
	width: 100%;
	height: 300px;
	.news-head{
		border-bottom: 2px solid #eee;
		height: 32px;
		h3{
			font-size: 16px;
			font-weight: bold;
			color: #333;
			position: relative;
			line-height: 30px;
			&:after{
				content: '';
				display: block;
				width: 100%;
				height: 2px;
				background-color: $--color-primary;
				position: absolute;
				left: 0;
				bottom: -2px;
			}
		}
	}
	.news-list{
		flex: 1;
		width: 100%;
		padding-top: 8px;
		.news-item{
			position: relative;
			padding-left:14px;
			line-height: 32px;
			&::before{
				content: '';
				display: block;
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #999;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
			}
			a{
				width: 100%;
				color: #333;
				.text-cut{
					flex: 1;
					display: block;
				}
				.time{
				}
			}
			&:hover{
				&:before{
					background-color: $--color-primary;
				}
				a{
					color: $--color-primary;
				}
			}
		}
	}
}
</style>
